import { 
  REQUEST_INSTA_AUDIENCE_CITY_SUCCESS,
  REQUEST_INSTA_AUDIENCE_COUNTRY_SUCCESS,
  REQUEST_INSTA_AUDIENCE_GENDERAGE_SUCCESS,
  REQUEST_INSTA_AUDIENCE_LOCAL_SUCCESS,
  REQUEST_INSTA_FOLLOWERS_ONLINE_SUCCESS
} from '../constants/actionTypes';

const INITIAL_STATE = { 
  city: null,
  country: null,
  genderage: null,
  local: null,
  followers_online: null,
  errors: null
};

export default function instaFollowers(state=INITIAL_STATE, action) {
  const {payload} = action;

  switch(action.type) {
    case REQUEST_INSTA_AUDIENCE_CITY_SUCCESS:
      return { ...state, city: payload };

    case REQUEST_INSTA_AUDIENCE_COUNTRY_SUCCESS:
      return { ...state, country: payload };

    case REQUEST_INSTA_AUDIENCE_GENDERAGE_SUCCESS:
      return { ...state, genderage: payload };

    case REQUEST_INSTA_AUDIENCE_LOCAL_SUCCESS:
      return { ...state, local: payload };
    
    case REQUEST_INSTA_FOLLOWERS_ONLINE_SUCCESS:
      return { ...state, followers_online: payload };

    default:
      return state;
  }
}